import RiyalIcon from "../../../../../icons/riyalIcon";
import Table from "../../../../../components/table/table";
const SalaryRateTab = ({ t }) => {
  const jobGrades = [
    {
      id: 1,
      jobTitle: "موظف",
      basicSalary: "3,500",
      housingAllowance: "20%",
      transportationAllowance: "10%",
      insurance: "5%",
      tax: "0%",
    },
    {
      id: 2,
      jobTitle: "مدير إدارة",
      basicSalary: "8,500",
      housingAllowance: "25%",
      transportationAllowance: "15%",
      insurance: "5%",
      tax: "2%",
    },
    {
      id: 3,
      jobTitle: "مدير إدارة",
      basicSalary: "12,500",
      housingAllowance: "30%",
      transportationAllowance: "20%",
      insurance: "10%",
      tax: "5%",
    },
    {
      id: 4,
      jobTitle: "مدير إدارة",
      basicSalary: "12,500",
      housingAllowance: "30%",
      transportationAllowance: "20%",
      insurance: "10%",
      tax: "5%",
    },
    {
      id: 5,
      jobTitle: "مدير إدارة",
      basicSalary: "12,500",
      housingAllowance: "30%",
      transportationAllowance: "20%",
      insurance: "10%",
      tax: "5%",
    },
    {
      id: 6,
      jobTitle: "مدير إدارة",
      basicSalary: "12,500",
      housingAllowance: "30%",
      transportationAllowance: "20%",
      insurance: "10%",
      tax: "5%",
    },
    {
      id: 7,
      jobTitle: "مدير تنفيذي",
      basicSalary: "17,500",
      housingAllowance: "30%",
      transportationAllowance: "20%",
      insurance: "10%",
      tax: "7%",
    },
  ];

  const tableHead = [
    {
      header: t("jobGrade"),
      accessorKey: "jobGrade",
    },
    {
      header: t("basicSalary"),
      accessorKey: "basicSalary",
    },
    {
      header: t("housingAllowance"),
      accessorKey: "housingAllowance",
    },
    {
      header: t("transportationAllowance"),
      accessorKey: "transportationAllowance",
    },
    {
      header: t("insurance"),
      accessorKey: "insurance",
    },

    {
      header: t("tax"),
      accessorKey: "tax",
    },
  ];
  const tableData = jobGrades.map((m, i) => {
    const basicSalary = (
      <span className="flex items-center justify-between p-3 border border-white rounded-lg w-[150px] mx-auto">
        {m.basicSalary}
        <RiyalIcon fill={"white"} className={"size-6"} />
      </span>
    );
    const housingAllowance = (
      <span className="flex items-center justify-center p-3 border border-white rounded-lg w-[150px] mx-auto">
        {m.housingAllowance}
      </span>
    );
    const transportationAllowance = (
      <span className="flex items-center justify-center p-3 border border-white rounded-lg w-[150px] mx-auto">
        {m.transportationAllowance}
      </span>
    );
    const insurance = (
      <span className="flex items-center justify-center p-3 border border-white rounded-lg w-[150px] mx-auto">
        {m.insurance}
      </span>
    );
    const tax = (
      <span className="flex items-center justify-center p-3 border border-white rounded-lg w-[150px] mx-auto">
        {m.tax}
      </span>
    );

    return {
      jobGrade: m.jobTitle,
      basicSalary,
      tax,
      insurance,
      transportationAllowance,
      housingAllowance,
    };
  });
  return (
    <div className="grid">
      <h2 className="text-lg font-bold capitalize">{t("payrollCalculationRules")}</h2>
      <Table TableData={tableData} TableHead={tableHead} />
    </div>
  );
};

export default SalaryRateTab;
